import React from 'react';
import { Link } from '@mui/material';

const LegalLink = ({ children, href }) => (
  <Link
    href={href}
    target="_blank"
    rel="noreferrer"
    sx={{ color: 'primary.main', textDecoration: 'none' }}
  >
    {children}
  </Link>
);

export default LegalLink;
